export function toLocalCurrency(locale: string, value: number, currency: string) {
	return value.toLocaleString(locale, {
		style: "currency",
		currency,
		minimumFractionDigits: 2
	})
}
export function toLocalNumber(locale: string, value: number) {
	return value.toLocaleString(locale, {
		style: "decimal",
		minimumFractionDigits: 2
	})
}
export function toLocalDate(locale: string, value: Date) {
	return value.toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" });
}

export function toCurrency(value: number, currency: string) {
	return value.toLocaleString(undefined, {
		style: "currency",
		currency,
		minimumFractionDigits: 2
	})
}
export function toNumber(value: number) {
	return value.toLocaleString(undefined, {
		style: "decimal",
		minimumFractionDigits: 2
	})
}
export function toDate(value: Date) {
	return value.toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
}
export const numericInputEventHandlers = {
	onKeyDown: restrictToNumeric,
	onPaste: handlePaste
}
function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
	const pastedText = e.clipboardData.getData("text");
	// Check if pasted text contains only numbers
	if (!/^\d*$/.test(pastedText)) {
		e.preventDefault();
	}
}
function restrictToNumeric(e: React.KeyboardEvent) {
	// Allow: backspace, delete, tab, escape, enter, arrows, home, end
	const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter",
		"ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
		"Home", "End"];
	// Allow special key combinations
	if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) {
		return;
	}

	// Allow functional keys
	if (allowedKeys.includes(e.key)) {
		return;
	}

	// Only allow numbers (0-9)
	if (!/^\d$/.test(e.key)) {
		e.preventDefault();
	}
}